import { render, staticRenderFns } from "./AffiliateEditDetails.vue?vue&type=template&id=63214e95&scoped=true&"
import script from "./AffiliateEditDetails.vue?vue&type=script&lang=js&"
export * from "./AffiliateEditDetails.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateEditDetails.vue?vue&type=style&index=0&id=63214e95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63214e95",
  null
  
)

export default component.exports